import React, {useEffect, useState} from 'react';
import {Dialog, DialogBackdrop, DialogPanel, DialogTitle} from "@headlessui/react";
import {FaExternalLinkAlt, FaTimes} from "react-icons/fa";
import Button from "../../../components/button";
import InputForm from "../../../components/input-form";
import InputDateTime from "../../../components/input-datetime";
import SelectComponent from "../../../components/select-component";
import useFetchData from "../hooks/use-fetch-data";
import general from "../../../utils/general";
import AttachesTable from "../../../components/attaches-table";
import {useQuery} from "@tanstack/react-query";
import userService from "../../../services/user-service";
import TextCorrectorComponent from "../../../components/text-corrector-component";
import FormField from "../../../components/react-hook-form/form-field";
import inputText from "../../../components/input-text";
import {FormProvider, useForm} from "react-hook-form";

const BASENAME = process.env.PUBLIC_URL;

const initialData = {
    id: "",
    deadline: "",
    title: "",
    description: "",
    groups: [],
    attachs: []
}

const ModalRequest = ({openModal, setOpenModal, attendance, save, request, hasRequestPermission, createGroups, attachesRef, software = true, afterSale = false, setIsLoading, correctorModule, correctorUrl}) => {
    const [state, setState] = useState(initialData);
    const [requesterOpt, setRequesterOpt] = useState([])

    const handleDateInput = (value, name) => setState(prev => ({...prev, [name]: value}));
    const handleInput = ({target: {name, value}}) => setState(prev => ({...prev, [name]: value}));
    const handleSelect = (value, name) => setState(prev => ({...prev, [name]: value}));
    const {modules} = useFetchData();

    const queryToSearch = afterSale ? attendance.project.map(a => a.value) : attendance.project

    useQuery({
        queryFn: () => userService.getMultiRequesters(queryToSearch).then(({data}) => {
            setRequesterOpt(data)
            return data
        }),
        queryKey: ["requesters"],
    });


    useEffect(() => {
        if (request) {
            const groups = request.groups.map(g => {
                return {label: g.name, value: g.id};
            });

            setState({
                id: request.id,
                deadline: request.deadline,
                title: request.title,
                description: request.description,
                groups: groups,
                attachs: request.attachs
            })
        }else{
            setState(createGroups)
        }
    }, [createGroups, request]);

    useEffect(() => {
        if (!software && request) setState(prev => ({...prev, requester: requesterOpt?.find(r => r.label === request.requester)}))
    }, [requesterOpt, request, software]);

    const submit = () => {
        const newData = {...state};
        newData.groups = newData.groups.map(m => m.value);
        save(newData);
    }

    const cancel = () => {
        setOpenModal(false)
        setState(initialData);
    }

    const openRequest = () => {
        window.open(`${BASENAME}/requests/form/${request.id}`);
    }

    const methods = useForm({
        values: state
    });

    return (
        <Dialog open={openModal} onClose={setOpenModal} className="relative z-10">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-10/12 overflow-y-auto m-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-start sm:p-8">
                    <DialogPanel transition
                                 className="relative transform rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 w-9/12 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95">
                        <div className="bg-white pt-1 border-b border-gray-300">
                            <div className="text-left">
                                <DialogTitle as="h3"
                                             className="font-semibold leading-6 border-b border-gray-300 px-3 flex justify-between">
                                    Solicitação
                                    <span onClick={() => setOpenModal(false)} className="cursor-pointer">
                                        <FaTimes/>
                                    </span>
                                </DialogTitle>
                                <div className="mt-4 mb-4 px-3">
                                    <div className={"ag-theme-quartz grid"}>
                                        <div className="grid grid-cols-1 gap-x-2 gap-y-5 sm:grid-cols-8">
                                            <p className={"col-span-1"}>
                                                Status:
                                                <kbd
                                                    className="ml-1 px-2 py-1 text-xs font-semibold text-gray-800 bg-gray-100 border border-gray-200 rounded-lg uppercase">
                                                    {request ? request.status : "Pendente"}
                                                </kbd>
                                            </p>
                                            <p className={"col-span-3"}>
                                                Projeto:
                                                <kbd
                                                    className="ml-1 px-2 py-1 text-xs font-semibold text-gray-800 bg-gray-100 border border-gray-200 rounded-lg ">
                                                    {attendance.project?.label ?? "-"}
                                                </kbd>
                                            </p>
                                            <p className={"col-span-2"}>
                                                Solicitante:
                                                <kbd
                                                    className="ml-1 px-2 py-1 text-xs font-semibold text-gray-800 bg-gray-100 border border-gray-200 rounded-lg ">
                                                    { request ? (request.requester ?? "-") : (attendance.requester?.label ?? "-")}
                                                </kbd>
                                            </p>
                                            <p className={"col-span-2"}>
                                                Atendente:
                                                <kbd
                                                    className="ml-1 px-2 py-1 text-xs font-semibold text-gray-800 bg-gray-100 border border-gray-200 rounded-lg ">
                                                    {request ? (request.responsible?.name ?? "-") : (attendance.responsible?.label ? attendance.responsible?.label : attendance.responsible )}
                                                </kbd>
                                            </p>

                                            {
                                                request && request.status !== "pendente" &&
                                                <>
                                                    <p className={"col-span-12"}>
                                                        Grupos:
                                                        <kbd
                                                            className="ml-1 px-2 py-1 text-xs font-semibold text-gray-800 bg-gray-100 border border-gray-200 rounded-lg ">
                                                            {request.groups.map(r => r.name).join(", ")}
                                                        </kbd>
                                                    </p>

                                                    <p className={"col-span-6"}>
                                                        Título:
                                                        <kbd
                                                            className="ml-1 px-2 py-1 text-xs font-semibold text-gray-800 bg-gray-100 border border-gray-200 rounded-lg ">
                                                            {request.title}
                                                        </kbd>
                                                    </p>
                                                    <p className={"col-span-6"}>
                                                        Prazo de entrega:
                                                        <kbd
                                                            className="ml-1 px-2 py-1 text-xs font-semibold text-gray-800 bg-gray-100 border border-gray-200 rounded-lg ">
                                                            {request.deadline ? general.formatDate(request.deadline, "DD/MM/YYYY") : "-"}
                                                        </kbd>
                                                    </p>


                                                    <p className={"col-span-12"}>
                                                        Descrição:
                                                        <kbd
                                                            className="ml-1 px-2 py-1 text-xs font-semibold text-gray-800 bg-gray-100 border border-gray-200 rounded-lg ">
                                                            {request.description}
                                                        </kbd>
                                                    </p>
                                                </>
                                            }

                                        </div>
                                    </div>

                                    {
                                        (request?.status === "pendente" || request === null) &&
                                        <>
                                            <div className="grid lg:grid-cols-12 gap-4 col-span-2 mt-4">
                                                <InputForm name="title" id={"title"} value={state.title}
                                                           onChange={handleInput}
                                                           label="Título" col="col-span-12 lg:col-span-9"/>
                                                <div className="col-span-12 lg:col-span-3">
                                                    <InputDateTime
                                                        id={"deadline"} name={"deadline"} label={"Prazo de entrega"}
                                                        selected={state.deadline}
                                                        onChange={(value) => handleDateInput(value, "deadline")}
                                                        showTime
                                                    />
                                                </div>

                                                <div className={`col-span-12 text-gray-900 ${software ? " lg:col-span-12" : " lg:col-span-9"}` }>
                                                    <SelectComponent
                                                        isMulti
                                                        instanceId="groups"
                                                        label="Grupos"
                                                        options={modules ?? []}
                                                        value={state.groups}
                                                        onChange={(value) => handleSelect(value, "groups")}
                                                        name="groups"
                                                    />
                                                </div>
                                                {
                                                    !software &&
                                                    <>
                                                        <div className="col-span-12 lg:col-span-3 text-gray-900">
                                                            <SelectComponent
                                                            instanceId="requester"
                                                            label="Solicitante"
                                                            options={requesterOpt ?? []}
                                                            value={state.requester}
                                                            onChange={(value) => handleSelect(value, "requester")}
                                                            name="requester"
                                                            />
                                                        </div>
                                                    </>
                                                }

                                                <div className="col-span-12">
                                                    <FormProvider {...methods}>
                                                        <div className={"space-y-4"}>
                                                            <TextCorrectorComponent setIsLoading={setIsLoading} setState={setState} name={"description"} module={correctorModule} url={correctorUrl}>
                                                                <FormField
                                                                    as={inputText}
                                                                    name={"description"}
                                                                    label={"Descrição"}
                                                                    textAreaClass={"h-40"}
                                                                    onChange={(e) => {
                                                                        const valor = e?.target?.value !== undefined ? e.target.value : e;

                                                                        setState(prev => ({ ...prev, description: valor }));
                                                                    }}
                                                                />
                                                            </TextCorrectorComponent>
                                                        </div>
                                                    </FormProvider>
                                                </div>
                                            </div>

                                            <AttachesTable attaches={state.attachs} gridRef={attachesRef} submit={submit}/>
                                        </>
                                    }

                                </div>
                                <div className={"body border-t border-gray-300 p-2 flex justify-end"}>
                                    {
                                        (request && hasRequestPermission) &&
                                        <Button onClick={openRequest}
                                                col={"col-span-2 mr-2"}>
                                            <FaExternalLinkAlt className={"mr-2"} /> Editar solicitação
                                        </Button>
                                    }
                                    <Button onClick={cancel} target="warning"
                                            col={"col-span-2 mr-2"}>
                                        Cancelar
                                    </Button>
                                    <Button onClick={submit} target="primary" col={"col-span-2"} disabled={request && request.status !== "pendente"}>
                                        {state.id ? "Editar" : "Gerar"}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    );
};

export default ModalRequest;
